var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logoError && _vm.EnterpriseId)?_c('span',[_c('img',{attrs:{"src":_vm.logoUrl,"title":"学校logo","id":"logo_common"},on:{"error":function (){ _vm.logoError=true; }}})]):_c('span',[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"id":"logo_common"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80b582ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/todoCenter/logo.vue
// module id = null
// module chunks = 